import { mainServerAxios } from ".";
import { loginAPIRoute } from "./functions/loginAPIRoute";

export const getPersonalInfoAPI = () =>
  mainServerAxios.get(loginAPIRoute("/user/getPersonalInfo"));
